// A PICKED THUMBNAIL, in one look wherever pictures or small cards are picked from a row: a 2 px
// blue border with a pale blue behind it. The caller's unpicked look carries its own border width
// (2 px, so picking moves nothing) and its own white.
export const PICKED = 'border-2 border-blue-500 bg-blue-50';
